<template>
  <div class="pb-8">
    <div
      v-if="!withNewscatcher"
      class="Content-from-Microsoft-Start"
      :class="{
        'small-layout': !isFiveTiles,
        'big-layout': isFiveTiles,
      }"
    >
      <a href="https://privacy.microsoft.com/en-US/privacystatement" target="_blank"
        >Content from Microsoft Start</a
      >
    </div>
    <div v-else class="newscatcher-content" />
    <div v-if="!isFiveTiles">
      <div v-for="(n, index) in counter" :key="selectedCategory + '-' + index">
        <LazyClassicNtpCommonNewsLayout
          :key="selectedCategory + '-' + index + '-carousel'"
          :news-items="NewsItems"
          :counter="index"
          :with-newscatcher="withNewscatcher"
          :with-programmatic="withProgrammatic"
        />
      </div>
    </div>
    <div v-else>
      <div v-for="(n, index) in counter" :key="selectedCategory + '-' + index">
        <LazyClassicNtpCommonNewsLayout1920
          :key="selectedCategory + '-' + index + '-carousel'"
          :news-items="NewsItems"
          :counter="index"
          :with-newscatcher="withNewscatcher"
          :with-programmatic="withProgrammatic"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
  import $ from 'jquery'
  import { useNewsStoreMSN } from '~~/store/NewsStoreMSN'
  import { sendMixpanelEvent } from '~/utils/host-browser-apis'
  import { useNewsStoreNewscatcher } from '~/store/NewsStoreNewscatcher'

  const isFiveTiles = computed({
    get() {
      return window.innerWidth >= 1920
    },
  })

  const ConteneMicrosoftWidth = isFiveTiles.value ? 1764 + 'px' : 1272 + 'px'
  const ConteneMicrosoftLeftPadding = isFiveTiles.value ? 84 + 'px' : 0

  const fixedClass = 'searchbox--fixed'
  let searchbox
  let threshold

  const props = defineProps({
    category: {
      type: Array,
      default: () => [],
    },
    withNewscatcher: {
      type: Boolean,
      default: false,
    },
    selectedCategory: {
      type: String,
      default: 'All',
    },
    withProgrammatic: {
      type: Boolean,
      default: false,
    },
  })

  let numberOfTiles = isFiveTiles.value ? 34 : 27

  const navBar = props.withNewscatcher
    ? {
        0: 'multiplecategories',
        1: 'News',
        2: 'Sports',
        3: 'Politics',
        4: 'Entertainment',
        5: 'Money',
        6: 'Lifestyle',
        7: 'Technology',
        8: 'Food',
        9: 'Travel',
        10: 'Health',
        11: 'Automotive',
        12: 'Shopping',
      }
    : {
        0: 'multiplecategories',
        1: 'News',
        2: 'Sports',
        3: 'Money',
        4: 'Lifestyle',
        5: 'Health',
        6: 'Shopping',
        7: 'Travel',
      }

  const loaded = ref([])

  const NewsItems = ref([])
  const counter = ref(0)

  const newsStore = props.withNewscatcher ? useNewsStoreNewscatcher() : useNewsStoreMSN()
  const currentDate = new Date()
  currentDate.setHours(0, 0, 0, 0)

  const isNewsAvailable = ref(false)
  let startIndex = 0
  let NewsItemsStore = []

  onMounted(() => {
    searchbox = document.querySelector('#searchbox')
    threshold = searchbox?.getBoundingClientRect()

    document.addEventListener('scroll', handleScroll)
    window.addEventListener('resize', fillAvailableSpaceWithTiles)
    fillAvailableSpaceWithTiles()
  })

  onBeforeMount(() => initialFetch())

  function fillAvailableSpaceWithTiles() {
    const availableTileSlots = calculateTileSlotsForAvailableScreenState()
    if (availableTileSlots <= startIndex) return

    const itemsToBeAdded = availableTileSlots - startIndex
    const endIndex = startIndex + itemsToBeAdded

    const windowHeight = window.innerHeight
    if (windowHeight > 1920) {
      const layoutForBigMonitors = document.querySelector('.layout-1920')?.offsetHeight || 1000
      const availableSpace = document.querySelector('.ntp')?.offsetHeight || windowHeight
      const availableRows = Math.ceil(availableSpace / layoutForBigMonitors)

      counter.value = availableRows
    }

    if (itemsToBeAdded > startIndex) {
      addToNewsItems(startIndex, endIndex)
      startIndex = endIndex
    }
  }

  window.fillAvailableSpaceWithTiles = fillAvailableSpaceWithTiles
  window.addToNewsItems = addToNewsItems
  window.loadNews = loadNews

  function calculateTileSlotsForAvailableScreenState() {
    try {
      const newsTile = document?.querySelector('[role="article"]')
      const newsTileHeight = newsTile?.offsetHeight || 250
      const newsTileWidth = newsTile?.offsetWidth || 300

      const availableSpace = document.querySelector('.ntp')

      const screenHeight = availableSpace.offsetHeight || 1
      const screenWidth = availableSpace.offsetWidth || 1

      const availableRows = Math.floor(screenHeight / newsTileHeight)
      const availableColumns = Math.floor(screenWidth / newsTileWidth)

      return availableRows * availableColumns * 2
    } catch (e) {
      console.error(e)
      return 0
    }
  }

  let position
  let searchboxUpdating = false

  if (process.client) {
    position = $(window).scrollTop()
  }

  function handleSearchbox() {
    if (threshold === undefined) {
      searchbox = document.querySelector('#searchbox')
      threshold = searchbox?.getBoundingClientRect()
    }
    if (window.scrollY > threshold.top || window.pageYOffset > threshold.top) {
      searchbox.classList.add(fixedClass)
    } else {
      searchbox.classList.remove(fixedClass)
    }
    searchboxUpdating = false
  }

  async function handleScroll() {
    let showFooter = true

    if (searchboxUpdating) {
      return
    } else {
      searchboxUpdating = true
      window.requestAnimationFrame(handleSearchbox)
    }

    if (window.innerHeight + window.scrollY >= document.body.scrollHeight) {
      showFooter = false
    }

    const scroll = $(window).scrollTop()
    if (scroll < position && showFooter) {
      $('#footer').css('position', 'fixed')
    } else {
      $('#footer').css('position', 'absolute')
    }
    position = scroll

    const a = document.documentElement.scrollTop + document.documentElement.clientHeight
    const b = document.documentElement.scrollHeight - 300

    if (a >= b && Math.floor((NewsItemsStore?.length - NewsItems.value.length) / numberOfTiles) >= 1) {
      loadNews(startIndex + numberOfTiles)
      await sendMixpanelEvent('NtpMoreNews_Loaded')
    }
  }

  function initialFetch() {
    let fetched = false
    for (let i = 1; i < props.category.length; i++) {
      if (props.category[i] && !loaded.value.includes(i)) {
        fetched = true
        fetchCategory(i)
      }
    }

    if (fetched) {
      buildCategoryNews()
    }

    if (!fetched) {
      props.withNewscatcher ? initialAllNewsFetchNewsCatcher() : initialAllNewsFetch()
    }
  }

  function fetchAPI(category, id) {
    const { data: NewsArticlesData } = useLazyFetch('/api/news/80' + '/' + 0 + '/' + id + '/' + category, {
      initialCache: false,
    })
    return NewsArticlesData
  }

  function fetchNewscatcherAPI(newsCategory) {
    const { data: NewsArticlesData } = useLazyFetch('/api/newscatcher', {
      params: {
        category: newsCategory,
      },
      initialCache: false,
    })
    return NewsArticlesData
  }

  function helper(category, newData, key) {
    if (!loaded.value.includes(category) && newData !== 'Error in parsing json') {
      loaded.value.push(category)
      newsStore[key] = JSON.stringify(newData)
      newsStore[key + '_fetched_on'] = currentDate
      filterNewsList(newData, key)

      // Display news when last category is fetched
      if (category === Object.keys(navBar).length - 1) {
        buildCategoryNews()
      }
    }
  }

  function initialAllNewsFetch() {
    let Id = generateRandomString(16)
    let fetchedCategoryData = null
    const newsDate = new Date(newsStore.News_fetched_on)
    if (newsStore.News != null && newsDate.getTime() === currentDate.getTime()) {
      loaded.value.push(1)
      fetchFromCache(1)
    } else {
      fetchedCategoryData = fetchAPI(navBar[1], Id)

      watch(fetchedCategoryData, (newData) => {
        helper(1, newData, 'News')
      })

      fetchedCategoryData = []
    }

    Id = generateRandomString(16)
    const sportsDate = new Date(newsStore.Sports_fetched_on)
    if (newsStore.Sports != null && sportsDate.getTime() === currentDate.getTime()) {
      loaded.value.push(2)
      fetchFromCache(2)
    } else {
      fetchedCategoryData = fetchAPI(navBar[2], Id)

      watch(fetchedCategoryData, (newData) => {
        helper(2, newData, 'Sports')
      })

      fetchedCategoryData = []
    }

    Id = generateRandomString(16)
    const moneyDate = new Date(newsStore.Money_fetched_on)
    if (newsStore.Money != null && moneyDate.getTime() === currentDate.getTime()) {
      loaded.value.push(3)
      fetchFromCache(3)
    } else {
      fetchedCategoryData = fetchAPI(navBar[3], Id)

      watch(fetchedCategoryData, (newData) => {
        helper(3, newData, 'Money')
      })

      fetchedCategoryData = []
    }

    Id = generateRandomString(16)
    const lifestyleDate = new Date(newsStore.Lifestyle_fetched_on)
    if (newsStore.Lifestyle != null && lifestyleDate.getTime() === currentDate.getTime()) {
      loaded.value.push(4)
      fetchFromCache(4)
    } else {
      fetchedCategoryData = fetchAPI(navBar[4], Id)

      watch(fetchedCategoryData, (newData) => {
        helper(4, newData, 'Lifestyle')
      })

      fetchedCategoryData = []
    }

    Id = generateRandomString(16)
    const healthDate = new Date(newsStore.Health_fetched_on)
    if (newsStore.Health != null && healthDate.getTime() === currentDate.getTime()) {
      loaded.value.push(5)
      fetchFromCache(5)
    } else {
      fetchedCategoryData = fetchAPI(navBar[5], Id)

      watch(fetchedCategoryData, (newData) => {
        helper(5, newData, 'Health')
      })

      fetchedCategoryData = []
    }

    Id = generateRandomString(16)
    const shoppingDate = new Date(newsStore.Shopping_fetched_on)
    if (newsStore.Shopping != null && shoppingDate.getTime() === currentDate.getTime()) {
      loaded.value.push(6)
      fetchFromCache(6)
    } else {
      fetchedCategoryData = fetchAPI(navBar[6], Id)

      watch(fetchedCategoryData, (newData) => {
        helper(6, newData, 'Shopping')
      })

      fetchedCategoryData = []
    }

    Id = generateRandomString(16)
    const travelDate = new Date(newsStore.Travel_fetched_on)
    if (newsStore.Travel != null && travelDate.getTime() === currentDate.getTime()) {
      loaded.value.push(7)
      fetchFromCache(7)
      buildCategoryNews()
    } else {
      fetchedCategoryData = fetchAPI(navBar[7], Id)

      watch(fetchedCategoryData, (newData) => {
        helper(7, newData, 'Travel')
      })

      fetchedCategoryData = []
    }
  }

  function initialAllNewsFetchNewsCatcher() {
    let fetchedCategoryData = null
    const newsDate = new Date(newsStore.News_fetched_on)
    if (newsStore.News != null && newsDate.getTime() === currentDate.getTime()) {
      loaded.value.push(1)
      fetchFromCache(1)
    } else {
      fetchedCategoryData = fetchNewscatcherAPI(navBar[1])

      watch(fetchedCategoryData, (newData) => {
        helper(1, newData, 'News')
      })

      fetchedCategoryData = []
    }

    const sportsDate = new Date(newsStore.Sports_fetched_on)
    if (newsStore.Sports != null && sportsDate.getTime() === currentDate.getTime()) {
      loaded.value.push(2)
      fetchFromCache(2)
    } else {
      fetchedCategoryData = fetchNewscatcherAPI(navBar[2])

      watch(fetchedCategoryData, (newData) => {
        helper(2, newData, 'Sports')
      })

      fetchedCategoryData = []
    }

    const politicsDate = new Date(newsStore.Politics_fetched_on)
    if (newsStore.Politics != null && politicsDate.getTime() === currentDate.getTime()) {
      loaded.value.push(3)
      fetchFromCache(3)
    } else {
      fetchedCategoryData = fetchNewscatcherAPI(navBar[3])

      watch(fetchedCategoryData, (newData) => {
        helper(3, newData, 'Politics')
      })

      fetchedCategoryData = []
    }

    const entertainmentDate = new Date(newsStore.Entertainment_fetched_on)
    if (newsStore.Entertainment != null && entertainmentDate.getTime() === currentDate.getTime()) {
      loaded.value.push(4)
      fetchFromCache(4)
    } else {
      fetchedCategoryData = fetchNewscatcherAPI(navBar[4])

      watch(fetchedCategoryData, (newData) => {
        helper(4, newData, 'Entertainment')
      })

      fetchedCategoryData = []
    }

    const moneyDate = new Date(newsStore.Money_fetched_on)
    if (newsStore.Money != null && moneyDate.getTime() === currentDate.getTime()) {
      loaded.value.push(5)
      fetchFromCache(5)
    } else {
      fetchedCategoryData = fetchNewscatcherAPI(navBar[5])

      watch(fetchedCategoryData, (newData) => {
        helper(5, newData, 'Money')
      })

      fetchedCategoryData = []
    }

    const lifestyleDate = new Date(newsStore.Lifestyle_fetched_on)
    if (newsStore.Lifestyle != null && lifestyleDate.getTime() === currentDate.getTime()) {
      loaded.value.push(6)
      fetchFromCache(6)
    } else {
      fetchedCategoryData = fetchNewscatcherAPI(navBar[6])

      watch(fetchedCategoryData, (newData) => {
        helper(6, newData, 'Lifestyle')
      })

      fetchedCategoryData = []
    }

    const technologyDate = new Date(newsStore.Technology_fetched_on)
    if (newsStore.Technology != null && technologyDate.getTime() === currentDate.getTime()) {
      loaded.value.push(7)
      fetchFromCache(7)
    } else {
      fetchedCategoryData = fetchNewscatcherAPI(navBar[7])

      watch(fetchedCategoryData, (newData) => {
        helper(7, newData, 'Technology')
      })

      fetchedCategoryData = []
    }

    const foodDate = new Date(newsStore.Food_fetched_on)
    if (newsStore.Food != null && foodDate.getTime() === currentDate.getTime()) {
      loaded.value.push(8)
      fetchFromCache(8)
    } else {
      fetchedCategoryData = fetchNewscatcherAPI(navBar[8])

      watch(fetchedCategoryData, (newData) => {
        helper(8, newData, 'Food')
      })

      fetchedCategoryData = []
    }

    const travelDate = new Date(newsStore.Travel_fetched_on)
    if (newsStore.Travel != null && travelDate.getTime() === currentDate.getTime()) {
      loaded.value.push(9)
      fetchFromCache(9)
    } else {
      fetchedCategoryData = fetchNewscatcherAPI(navBar[9])

      watch(fetchedCategoryData, (newData) => {
        helper(9, newData, 'Travel')
      })

      fetchedCategoryData = []
    }

    const healthDate = new Date(newsStore.Health_fetched_on)
    if (newsStore.Health != null && healthDate.getTime() === currentDate.getTime()) {
      loaded.value.push(10)
      fetchFromCache(10)
    } else {
      fetchedCategoryData = fetchNewscatcherAPI(navBar[10])

      watch(fetchedCategoryData, (newData) => {
        helper(10, newData, 'Health')
      })

      fetchedCategoryData = []
    }

    const automotiveDate = new Date(newsStore.Automotive_fetched_on)
    if (newsStore.Automotive != null && automotiveDate.getTime() === currentDate.getTime()) {
      loaded.value.push(11)
      fetchFromCache(11)
    } else {
      fetchedCategoryData = fetchNewscatcherAPI(navBar[11])

      watch(fetchedCategoryData, (newData) => {
        helper(11, newData, 'Automotive')
      })

      fetchedCategoryData = []
    }

    const shoppingDate = new Date(newsStore.Shopping_fetched_on)
    if (newsStore.Shopping != null && shoppingDate.getTime() === currentDate.getTime()) {
      loaded.value.push(12)
      fetchFromCache(12)
      buildCategoryNews()
    } else {
      fetchedCategoryData = fetchNewscatcherAPI(navBar[12])

      watch(fetchedCategoryData, (newData) => {
        helper(12, newData, 'Shopping')
      })

      fetchedCategoryData = []
    }
  }

  function fetchFromCache(category) {
    const newsDataArray = JSON.parse(newsStore[navBar[category]])
    const handler = {}
    const newsProxy = new Proxy(newsDataArray, handler)
    filterNewsList(newsProxy, navBar[category])
  }

  onBeforeUnmount(() => {
    document.removeEventListener('scroll', handleScroll)
  })

  function generateRandomString(len) {
    let randomString = ''
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    for (let i = 0; i < len; i++) {
      randomString += characters.charAt(Math.floor(Math.random() * characters.length))
    }
    randomString = randomString.match(/.{1,4}/g).join('-')
    localStorage.setItem('activityID', randomString)
    return randomString
  }

  const categoryComputed = computed({
    get() {
      return props.category.slice()
    },
  })

  function fetchCategory(category) {
    let fetchedCategoryData = null
    const Id = generateRandomString(16)
    const categoryDate = new Date(newsStore[navBar[category] + '_fetched_on'])
    if (newsStore[navBar[category]] != null && categoryDate.getTime() === currentDate.getTime()) {
      fetchFromCache(category)
      loadNews(startIndex + numberOfTiles)
    } else {
      try {
        fetchedCategoryData = props.withNewscatcher
          ? fetchNewscatcherAPI(navBar[category])
          : fetchAPI(navBar[category], Id)
      } catch {
        loadNews(startIndex + numberOfTiles)
      }

      watch(fetchedCategoryData, (newData) => {
        if (!loaded.value.includes(category) && newData !== 'Error in parsing json') {
          loaded.value.push(category)
          newsStore[navBar[category]] = JSON.stringify(newData)
          newsStore[navBar[category] + '_fetched_on'] = currentDate
          filterNewsList(newData, navBar[category])
          buildCategoryNews()
        }
      })

      fetchedCategoryData = []
    }
  }

  function reset() {
    isNewsAvailable.value = false
    NewsItemsStore = []
    NewsItems.value = []
    counter.value = 0
    startIndex = 0
    numberOfTiles = isFiveTiles.value ? 34 : 27
  }

  watch(categoryComputed, (newValue, oldValue) => {
    let i = 0
    reset()
    if (newValue[0] === true) {
      props.withNewscatcher ? initialAllNewsFetchNewsCatcher() : initialAllNewsFetch()
    } else {
      for (i = 1; i < newValue.length; i++) {
        if (newValue[i] !== oldValue[i]) {
          if (newValue[i]) {
            fetchCategory(i)
          }
          if (!newValue[i] && loaded.value.includes(i)) {
            loaded.value = loaded.value.filter((item) => item !== i)
          }
        }
      }
    }
  })

  function addToNewsItems(startIndex, endIndex) {
    if (NewsItemsStore?.length > 0) {
      const addNews = NewsItemsStore?.slice(startIndex, endIndex)
      addNews.forEach((element) => {
        NewsItems.value.push(element)
      })
    }

    if (counter.value < Math.floor(NewsItems.value.length / numberOfTiles)) {
      counter.value += 1
    }

    numberOfTiles = isFiveTiles.value ? 21 : 16
  }

  function loadNews(endIndex) {
    addToNewsItems(startIndex, endIndex)
    startIndex = endIndex
  }

  function shuffle() {
    let currentIndex = NewsItemsStore.length
    let randomIndex

    // While there remain elements to shuffle.
    while (currentIndex !== 0) {
      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex)
      currentIndex--

      // And swap it with the current element.
      ;[NewsItemsStore[currentIndex], NewsItemsStore[randomIndex]] = [
        NewsItemsStore[randomIndex],
        NewsItemsStore[currentIndex],
      ]
    }
  }

  function filterNewsList(NewsArticles, category) {
    if (typeof NewsArticles === 'object' && NewsArticles?.length > 0) {
      let NewsItemsList = null

      if (props.withNewscatcher) {
        NewsItemsList = NewsArticles?.filter(
          (x) =>
            x.ThumbnailUrl !== undefined &&
            x.Provider !== undefined &&
            x.Title !== undefined &&
            x.TargetedUrl !== undefined &&
            x.news_category !== undefined
        )
      } else {
        NewsItemsList = NewsArticles?.filter(
          (x) =>
            x.ThumbnailUrl !== undefined &&
            x.Provider !== undefined &&
            x.Title !== undefined &&
            x.TargetedUrl !== undefined &&
            x.Topics !== undefined
        )
      }

      NewsItemsList.forEach(function (obj) {
        obj.news_category = category
      })

      NewsItemsStore.push(...NewsItemsList)
      // Only shuffle if All is selected otherwise display articles in same order as they are stored
      if (categoryComputed.value[0]) {
        shuffle()
      }
    }
  }

  function buildCategoryNews() {
    if (NewsItemsStore?.length > 0 && !isNewsAvailable.value) {
      startIndex = 0
      isNewsAvailable.value = true
      numberOfTiles = isFiveTiles.value ? 34 : 27
      loadNews(startIndex + numberOfTiles)
    }
  }
</script>

<style lang="scss" scoped>
  .Content-from-Microsoft-Start {
    width: v-bind(ConteneMicrosoftWidth);
    height: 16px;
    flex-grow: 0;
    font-size: 14px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
    text-align: left;
    color: $onelaunch-ui-shades-700;
    margin: 8px auto 4px;
    padding-left: v-bind(ConteneMicrosoftLeftPadding);

    a {
      color: #a0a0a0;
      font-size: 12px;
      font-style: italic;
    }
  }

  .newscatcher-content {
    margin-bottom: 8px;
    margin-left: auto;
    margin-right: auto;
  }

  .small-layout {
    @media (max-width: 1360px) {
      width: 948px;
      padding: 0;
    }

    @media (max-width: 1034px) {
      width: 624px;
      padding: 0;
    }

    @media (max-width: 724px) {
      width: 300px;
      padding: 0;
    }
  }

  .big-layout {
    @media (max-width: 1860px) {
      width: 1272px;
      padding: 0;
    }

    @media (max-width: 1506px) {
      width: 948px;
      padding: 0;
    }

    @media (max-width: 1145px) {
      width: 624px;
      padding: 0;
    }

    @media (max-width: 772px) {
      width: 300px;
      padding: 0;
    }
  }
</style>
